import { useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import { css } from '@emotion/react';
import Uppy from '@uppy/core';
import Dashboard from '@uppy/dashboard';
// import AwsS3 from '@uppy/aws-s3'; // descomente ao conectar o S3
import '@uppy/core/dist/style.css';
import '@uppy/dashboard/dist/style.css';

const containerStyle = css({
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    padding: '32px',
});

export function QueueProcessingLocalUpload() {
    const dashboardRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const uppy = new Uppy({
            restrictions: {
                maxNumberOfFiles: 20,
            },
        });

        uppy.use(Dashboard, {
            target: dashboardRef.current!,
            inline: true,
            height: 470,
        });

        // TODO: configure S3 connection
        /*uppy.use(AwsS3, {
            shouldUseMultipart: true,
            endpoint: '',
            getUploadParameters: async (file) => ({
                method: 'PUT',
                url: '',
                fields: {},
                headers: { 'Content-Type': file.type ?? 'application/octet-stream' },
            }),
        });*/

        return () => {
            //uppy.destroy();
        };
    }, []);

    return (
        <Box css={containerStyle}>
            <div ref={dashboardRef} />
        </Box>
    );
}
